import { render, staticRenderFns } from "./container_delegation.vue?vue&type=template&id=157ddb38&scoped=true&"
import script from "./container_delegation.vue?vue&type=script&lang=js&"
export * from "./container_delegation.vue?vue&type=script&lang=js&"
import style0 from "./container_delegation.vue?vue&type=style&index=0&id=157ddb38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157ddb38",
  null
  
)

export default component.exports